import appear, { type AppearOptions } from "@client/lib/jquery/appear";
import { makeWith, makeWrap } from "./factory";

export interface AppearProps {
  appearOptions: AppearOptions;
}

export const withAppear = makeWith<AppearProps>(
  (element: HTMLElement, props: AppearProps) => appear(element, props.appearOptions),
  "appearOptions"
);

const appearTag = makeWrap<AppearProps>(withAppear);
export default appearTag;
